import debounce from 'debounce';
// import RemoteController from './RemoteController';
// import sessionConfig from './session.json';

// export const setupRemoteControl = (store, currentChannelIndex) => {
//   const remoteController = new RemoteController(store, currentChannelIndex);
//
//   const immediate = true;
//   const backButtonHandler = debounce((state) => {
//     if (state.player.fullscreen) {
//       if (!state.player.isVod) {
//         remoteController.exitFullscreen();
//       }
//     } else if (state.guideinternal.maximized) {
//       remoteController.minimizeGuide();
//     } else if (window.VIZIO && typeof window.VIZIO.exitApplication === 'function') {
//       window.VIZIO.exitApplication();
//     }
//   }, 1000, immediate);
//
//   const okButtonHandler = debounce((state) => {
//     if (state.player.fullscreen) {
//       remoteController.exitFullscreen();
//     } else {
//       remoteController.enterFullscreen();
//     }
//   }, 1000, immediate);
//
//   const exitFullscreenHandler = (state) => {
//     if (state.player.fullscreen) {
//       remoteController.exitFullscreen();
//     }
//   };
//
//   const enterFullscreenHandler = (state) => {
//     if (!state.player.fullscreen) {
//       remoteController.enterFullscreen();
//     }
//   };
//
//   const channelUpHandler = () => {
//     remoteController.channelUp();
//   };
//
//   const channelDownHandler = () => {
//     remoteController.channelDown();
//   };
//
//   const controllerKeyHandler = [
//     ['back', 8, 27, backButtonHandler],
//     ['ok', 13, okButtonHandler],
//     ['left', 37, exitFullscreenHandler],
//     ['right', 39, enterFullscreenHandler],
//     ['channelUp', 34, 38, channelUpHandler],
//     ['channelDown', 33, 40, 500, channelDownHandler],
//   ];
//
//   window.onkeydown = (ev) => {
//     const state = store.getState();
//
//     const handler = controllerKeyHandler.find(i => i.includes(ev.keyCode || ev.which || ev));
//     if (handler) {
//       const [name, ...keyCodesAndFunction] = handler;
//       const handlerFunction = keyCodesAndFunction.pop();
//
//       console.log(`Executing key down handler: ${name}`);
//       handlerFunction(state);
//     }
//   };
//
//   return remoteController;
// };

export const generateSessionId = () => (Math.random() * 1e32).toString(36);

// export const getSession = deviceType => ({
//   sid: generateSessionId(),
//   ...sessionConfig.default,
//   ...sessionConfig[deviceType],
// });

export const findCurrentTimeline = (timelines) => {
  const now = new Date();

  return timelines.find((timeline) => {
    const start = new Date(timeline.start);
    const stop = new Date(timeline.stop);

    return now >= start && now < stop;
  });
};

/* TODO
  generate
  - device id
  - browser type
  - user id (if avail)
  - refer to Spencer / Mike Y. for vals to pass
*/
export const generateStream = (channelId) =>
  `https://stitcher.pluto.tv/stitch/hls/channel/${channelId}/master.m3u8?deviceType=web&serverSideAds=true&deviceMake=safari&deviceVersion=1&deviceId=spencer&appVersion=1&deviceDNT=0&deviceModel=web&sid=yasirProd`;

export const getCurrentShow = (channel = {}) => {
  // console.log('getCurrentShow');
  const currentTimeline = findCurrentTimeline(channel.schedule || channel.timelines || []);

  if (!currentTimeline) {
    return {};
  }

  return currentTimeline;
};

export const generateVODStream = (urls) => {
  // eslint-disable-next-line prefer-destructuring
  for (let i = 0, length = urls.length; i < length; i += 1) {
    if (urls[i].type === 'hls') {
      return urls[i].url;
    }
  }

  return null;
};

export const easing = (t) => (t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t);
